import Constant from '../../const';
const axios = require('axios');

const postModifyQueue = async ({ payload }) => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/queue/next'),
      payload,
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default postModifyQueue;
